/**
 * Payments Service — records payments against invoices
 */
import { z } from 'zod'
import { post } from '@/lib/api-client'

const PaymentResponseSchema = z.object({
  id: z.string(),
  invoice_id: z.string(),
  amount: z.number(),
  currency: z.string(),
  payment_method: z.string(),
  status: z.string(),
  notes: z.string().nullable().optional(),
  processed_at: z.string().nullable().optional(),
  created_at: z.string(),
})

export type PaymentResponse = z.infer<typeof PaymentResponseSchema>

export const paymentsService = {
  async recordPayment(data: {
    invoice_id: string
    amount: number
    currency: string
    payment_method: string
    notes?: string
  }): Promise<PaymentResponse> {
    return post('/payments', data, PaymentResponseSchema)
  },
}
